/**
 * useMenuConfig — fetches the admin-managed main navigation menu from
 * /api/menu once per session (module-level cache). The public Header renders
 * from this instead of hardcoded links. Falls back to DEFAULT_MENU (which
 * mirrors the historical hardcoded nav) so the site never breaks.
 */
import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export const DEFAULT_MENU = {
  items: [
    { id: 'home', label: 'Home', link: '/', target: '_self', visible: true, is_cta: false, children: [] },
    { id: 'packages', label: 'Party Packages', link: '/#packages', target: '_self', visible: true, is_cta: false, children: [] },
    { id: 'contact', label: 'Contact Us', link: '/contact', target: '_self', visible: true, is_cta: false, children: [] },
    { id: 'rewards', label: 'Rewards', link: '/loyalty-program', target: '_self', visible: true, is_cta: false, children: [] },
    { id: 'gift', label: 'Gift Cards', link: '/gift-cards', target: '_self', visible: true, is_cta: false, children: [] },
    { id: 'book', label: 'Book Now', link: '/book', target: '_self', visible: true, is_cta: true, cta_bg: '#FF3B6B', cta_color: '#FFFFFF', children: [] },
  ],
  style: {
    font: '"Poppins", sans-serif', size: 'base', weight: '500',
    text_color: '#6B6B7A', hover_color: '#1E1E24', bg_color: '',
    sticky: true, align: 'right', show_logo: true,
  },
};

let _cache = null;
let _inflight = null;

export const invalidateMenuCache = () => { _cache = null; };

const fetchMenu = () => {
  if (_cache) return Promise.resolve(_cache);
  if (_inflight) return _inflight;
  _inflight = fetch(`${API_URL}/api/menu`)
    .then((r) => (r.ok ? r.json() : null))
    .catch(() => null)
    .then((data) => {
      _cache = data && data.items ? { items: data.items, style: { ...DEFAULT_MENU.style, ...(data.style || {}) } } : DEFAULT_MENU;
      _inflight = null;
      return _cache;
    });
  return _inflight;
};

export const useMenuConfig = () => {
  const [menu, setMenu] = useState(_cache || DEFAULT_MENU);
  useEffect(() => {
    let ok = true;
    fetchMenu().then((m) => { if (ok) setMenu(m); });
    return () => { ok = false; };
  }, []);
  return menu;
};

export default useMenuConfig;
